import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Check, X, BellRing } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STATUS = {
  pending: { label: "In attesa", cls: "bg-gold-light text-ink" },
  confirmed: { label: "Confermata", cls: "bg-pine-light text-pine-dark" },
  declined: { label: "Rifiutata", cls: "bg-clay/15 text-clay-dark" },
};

const BookingRow = ({ b, token, onUpdate }) => {
  const [busy, setBusy] = useState(false);
  const st = STATUS[b.status] || STATUS.pending;

  const act = async (action) => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/admin/bookings/${b.id}/${action}`, null, { headers: { Authorization: `Bearer ${token}` } });
      onUpdate({ ...b, status: data.status });
      toast.success(data.emailed ? `${STATUS[data.status].label} · email inviata al cliente` : `${STATUS[data.status].label} (email non inviata)`);
    } catch {
      toast.error("Operazione non riuscita");
    } finally {
      setBusy(false);
    }
  };

  return (
    <li className="p-4 text-sm" data-testid={`booking-row-${b.id}`}>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <span className="font-mono text-pine font-semibold">{b.date} · {b.time}</span>
        <span className="text-ink font-medium">{b.name}</span>
        <a href={`mailto:${b.email}`} className="text-muted hover:text-pine">{b.email}</a>
        {b.phone && <span className="text-muted">{b.phone}</span>}
        <span className="text-[11px] font-mono uppercase tracking-wider text-sage">{b.mode} · {b.lang}</span>
        <span className={`rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${st.cls}`} data-testid={`booking-status-${b.id}`}>{st.label}</span>
        {b.reminder_sent && <span className="inline-flex items-center gap-1 text-[11px] text-sage"><BellRing size={11} /> promemoria inviato</span>}
        <span className="ml-auto flex gap-2">
          {b.status !== "confirmed" && (
            <button type="button" disabled={busy} onClick={() => act("confirm")} data-testid={`booking-confirm-${b.id}`} className="inline-flex items-center gap-1 rounded-full bg-pine px-3.5 py-1.5 text-xs font-semibold text-linen hover:bg-pine-dark disabled:opacity-50"><Check size={13} /> Conferma</button>
          )}
          {b.status !== "declined" && (
            <button type="button" disabled={busy} onClick={() => act("decline")} data-testid={`booking-decline-${b.id}`} className="inline-flex items-center gap-1 rounded-full border border-clay px-3.5 py-1.5 text-xs font-semibold text-clay-dark hover:bg-clay hover:text-white disabled:opacity-50"><X size={13} /> Rifiuta</button>
          )}
        </span>
      </div>
      {b.notes && <p className="text-muted text-xs mt-2">{b.notes}</p>}
    </li>
  );
};

export const BookingList = ({ bookings, token, onUpdate }) => {
  if (bookings.length === 0) return <p className="text-sm text-muted" data-testid="bookings-empty">Nessuna prenotazione in programma.</p>;
  return (
    <ul className="divide-y divide-border rounded-2xl border border-border bg-white" data-testid="bookings-list">
      {bookings.map((b) => <BookingRow key={b.id} b={b} token={token} onUpdate={onUpdate} />)}
    </ul>
  );
};
